/* assets/main-product-premium.js
   Vanilla JS. No jQuery. No global leakage beyond one init function that
   Shopify's section-rendering API can call again on section:load. */

(function () {
  'use strict';

  function initProductSection(root) {
    if (!root || root.dataset.lwInit === 'true') return;
    root.dataset.lwInit = 'true';

    initGallery(root);
    initVariantPicker(root);
    initQuantity(root);
    initBuyForm(root);
  }

  /* ---------------- Gallery ---------------- */
  function initGallery(root) {
    var gallery = root.querySelector('[data-gallery]');
    if (!gallery) return;

    var stage = gallery.querySelector('[data-gallery-stage]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    var fullscreenBtn = gallery.querySelector('[data-gallery-fullscreen]');

    function activate(mediaId) {
      slides.forEach(function (slide) {
        slide.classList.toggle('is-active', slide.dataset.mediaId === mediaId);
      });
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.dataset.mediaId === mediaId);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activate(thumb.dataset.mediaId);
      });
    });

    function step(direction) {
      var activeIndex = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      if (activeIndex === -1) return;
      var nextIndex = (activeIndex + direction + slides.length) % slides.length;
      activate(slides[nextIndex].dataset.mediaId);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    if (fullscreenBtn && stage) {
      fullscreenBtn.addEventListener('click', function () {
        if (document.fullscreenElement) {
          document.exitFullscreen();
        } else if (stage.requestFullscreen) {
          stage.requestFullscreen();
        }
      });
    }

    // Hover / click zoom toggle on desktop
    if (stage) {
      stage.addEventListener('click', function (e) {
        if (e.target.closest('[data-gallery-fullscreen], [data-gallery-prev], [data-gallery-next]')) return;
        gallery.classList.toggle('is-zoomed');
      });
    }

    // Basic touch swipe
    var touchStartX = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (touchStartX === null) return;
        var delta = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(delta) > 40) step(delta > 0 ? -1 : 1);
        touchStartX = null;
      }, { passive: true });
    }
  }

  /* ---------------- Variant picker ---------------- */
  function initVariantPicker(root) {
    var picker = root.querySelector('[data-variant-picker]');
    if (!picker) return;

    var variantJsonEl = picker.querySelector('[data-variant-json]') || root.querySelector('[data-product-variants-json]');
    var variants = [];
    try { variants = variantJsonEl ? JSON.parse(variantJsonEl.textContent) : []; } catch (e) { variants = []; }

    var options = Array.prototype.slice.call(picker.querySelectorAll('[data-option-index]'));

    function getSelections() {
      return options.map(function (fieldset) {
        var select = fieldset.querySelector('[data-option-selector]');
        if (select) return select.value;
        var active = fieldset.querySelector('.lw-swatch.is-selected');
        return active ? active.dataset.optionValue : null;
      });
    }

    function findMatchingVariant(selections) {
      return variants.find(function (v) {
        var vOptions = [v.option1, v.option2, v.option3];
        return selections.every(function (sel, i) { return sel === null || vOptions[i] === sel; });
      });
    }

    function updateUI(variant) {
      if (!variant) return;

      var idInput = root.querySelector('[data-variant-id-input]');
      if (idInput) idInput.value = variant.id;

      var priceCurrent = root.querySelector('[data-price-current]');
      var priceCompare = root.querySelector('[data-price-compare]');
      var priceDiscount = root.querySelector('[data-price-discount]');
      if (priceCurrent) priceCurrent.textContent = formatMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (priceCompare) { priceCompare.textContent = formatMoney(variant.compare_at_price); priceCompare.hidden = false; }
        if (priceDiscount) {
          var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          priceDiscount.textContent = '-' + pct + '%';
          priceDiscount.hidden = false;
        }
      } else {
        if (priceCompare) priceCompare.hidden = true;
        if (priceDiscount) priceDiscount.hidden = true;
      }

      var availabilityEl = root.querySelector('[data-availability]');
      if (availabilityEl) {
        availabilityEl.classList.toggle('is-in-stock', !!variant.available);
        availabilityEl.classList.toggle('is-out-of-stock', !variant.available);
      }

      var addBtn = root.querySelector('[data-add-to-cart]');
      var addText = root.querySelector('[data-add-to-cart-text]');
      if (addBtn) addBtn.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? addText.dataset.available || addText.textContent : (addText.dataset.soldOut || 'Sold Out');

      if (variant.featured_media && variant.featured_media.id) {
        var mediaId = String(variant.featured_media.id);
        var thumb = root.querySelector('[data-gallery-thumb][data-media-id="' + mediaId + '"]');
        if (thumb) thumb.click();
      }

      var stickyPrice = root.parentElement ? root.parentElement.querySelector('[data-sticky-price]') : null;
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
    }

    options.forEach(function (fieldset) {
      fieldset.addEventListener('click', function (e) {
        var swatch = e.target.closest('.lw-swatch');
        if (!swatch) return;
        fieldset.querySelectorAll('.lw-swatch').forEach(function (s) { s.classList.remove('is-selected'); s.setAttribute('aria-pressed', 'false'); });
        swatch.classList.add('is-selected');
        swatch.setAttribute('aria-pressed', 'true');
        var label = fieldset.querySelector('[data-selected-value]');
        if (label) label.textContent = swatch.dataset.optionValue;
        updateUI(findMatchingVariant(getSelections()));
      });

      var select = fieldset.querySelector('[data-option-selector]');
      if (select) {
        select.addEventListener('change', function () {
          var label = fieldset.querySelector('[data-selected-value]');
          if (label) label.textContent = select.value;
          updateUI(findMatchingVariant(getSelections()));
        });
      }
    });
  }

  function formatMoney(cents) {
    // Falls back to a simple format; theme's `Shopify.formatMoney` is used
    // when available for correct currency/locale formatting.
    var format = window.lwMoneyFormat || window.moneyFormat;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && format) {
      return window.Shopify.formatMoney(cents, format);
    }
    return (cents / 100).toFixed(2);
  }

  /* ---------------- Quantity ---------------- */
  function initQuantity(root) {
    var input = root.querySelector('[data-qty-input]');
    if (!input) return;
    var dec = root.querySelector('[data-qty-decrease]');
    var inc = root.querySelector('[data-qty-increase]');

    if (dec) dec.addEventListener('click', function () {
      var val = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = val;
    });
    if (inc) inc.addEventListener('click', function () {
      var val = (parseInt(input.value, 10) || 1) + 1;
      input.value = val;
    });
  }

  /* ---------------- Buy form / add to cart ---------------- */
  function initBuyForm(root) {
    var form = root.querySelector('[data-buy-form]');
    if (!form) return;

    var qtyInput = root.querySelector('[data-qty-input]');
    if (qtyInput && !form.querySelector('input[name="quantity"]')) {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'quantity';
      form.appendChild(hidden);
    }

    form.addEventListener('submit', function () {
      var qty = form.querySelector('input[name="quantity"]');
      if (qty && qtyInput) qty.value = qtyInput.value;
    });

    var stickyAdd = document.querySelector('[data-sticky-add-to-cart]');
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        var addBtn = root.querySelector('[data-add-to-cart]');
        if (addBtn) addBtn.click();
      });
    }
  }

  /* ---------------- Sticky bar visibility ---------------- */
  function initStickyBarObserver(sectionRoot) {
    var stickyBar = document.querySelector('[data-sticky-bar]');
    var buyBox = sectionRoot.querySelector('.lw-buybox');
    if (!stickyBar || !buyBox || !('IntersectionObserver' in window)) return;

    stickyBar.hidden = false;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    observer.observe(buyBox);
  }

  function bootAll() {
    document.querySelectorAll('[data-section-type="main-product-premium"]').forEach(function (root) {
      initProductSection(root);
      initStickyBarObserver(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  // Shopify Theme Editor: re-init when this section is re-rendered/added.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-section-type="main-product-premium"]');
    if (root) {
      root.dataset.lwInit = 'false';
      initProductSection(root);
      initStickyBarObserver(root);
    }
  });
})();
